const { get } = require( '@/http/index.js' )

export class Base {
	sharePage_index( id ) {
		return get( `/ac1/conference/sharePage/index?id=${ id }` )
	}

	shares_detail( id ) {
		return get( `/ac1/conference/newsDetail?id=${ id }&isFilter=1` )
	}

	shares_video_detail( id ) {
		return get( `/ac1/conference/column/videoDetail?id=${ id }` )
	}

	shares_list( id ) {
		return get( `/ac1/conference/column/newsList?id=${ id }&isFilter=1` )
	}

	shares_video_list( id ) {
		return get( `/ac1/conference/column/videoList?id=${ id }` )
	}

}
